import "./NoBill.css";

const NoBill = ({ title, Icon }) => {
  /*Los props van en Titulo y Icono*/
  return (
    <div className="boxnotdatabill">
      <div>
        <Icon className="iconnotbill" />
      </div>
      <div className="boxtittlebill">
        <p className="tittlenotdatabill">{title}</p>
      </div>
      <div className="boxexplainnotdatabill">
        <p className="explainotdatabill">
          Espere al siguiente mes para enviar una factura nueva
        </p>
      </div>
    </div>
  );
};

export default NoBill;
